[
  "/alexandria-handwriting/webps-no-bg/ahzam.webp",
  "/alexandria-handwriting/webps-no-bg/andy.webp",
  "/alexandria-handwriting/webps-no-bg/bonney.webp",
  "/alexandria-handwriting/webps-no-bg/brinlee.webp",
  "/alexandria-handwriting/webps-no-bg/carmen1.webp",
  "/alexandria-handwriting/webps-no-bg/carmen2.webp",
  "/alexandria-handwriting/webps-no-bg/fateen1.webp",
  "/alexandria-handwriting/webps-no-bg/fateen2.webp",
  "/alexandria-handwriting/webps-no-bg/grace.webp",
  "/alexandria-handwriting/webps-no-bg/heather1.webp",
  "/alexandria-handwriting/webps-no-bg/heather2.webp",
  "/alexandria-handwriting/webps-no-bg/riley.webp",
  "/alexandria-handwriting/webps-no-bg/sharif.webp",
  "/alexandria-handwriting/webps-no-bg/subby.webp",
  "/alexandria-handwriting/webps-no-bg/trisha2.webp"
]
